module.exports = __webpack_public_path__ + "static/media/Simple-Line-Icons.de8ad55b.svg";